import { useState, useEffect } from "react";

const listings = [
{ id: 1, title: "Vintage Leather Sofa", price: 120, condition: "used", category: "Furniture", seller: "Maria K.", distance: "0.3 mi", emoji: "🛋️", auction: false, img: "bg-orange-100", badge: "Hot Deal" },
{ id: 2, title: "Kids Bicycle (Blue)", price: 45, condition: "used", category: "Sports", seller: "Tom H.", distance: "0.5 mi", emoji: "🚲", auction: false, img: "bg-blue-100", badge: null },
{ id: 3, title: "Brand New Air Fryer", price: 89, condition: "new", category: "Kitchen", seller: "Sara L.", distance: "0.8 mi", emoji: "🍟", auction: false, img: "bg-yellow-100", badge: "New" },
{ id: 4, title: "Antique Wall Clock", price: 200, condition: "used", category: "Decor", seller: "James R.", distance: "1.1 mi", emoji: "🕰️", auction: true, img: "bg-amber-100", badge: "🔨 Auction" },
{ id: 5, title: "PS5 Controller", price: 55, condition: "used", category: "Gaming", seller: "Alex P.", distance: "0.2 mi", emoji: "🎮", auction: false, img: "bg-purple-100", badge: null },
{ id: 6, title: "Succulent Plant Set", price: 18, condition: "new", category: "Garden", seller: "Nina B.", distance: "0.6 mi", emoji: "🌵", auction: false, img: "bg-green-100", badge: "New" },
{ id: 7, title: "Vintage Camera Leica", price: 340, condition: "used", category: "Electronics", seller: "Paul M.", distance: "1.3 mi", emoji: "📷", auction: true, img: "bg-red-100", badge: "🔨 Auction" },
{ id: 8, title: "Handmade Ceramic Mugs", price: 28, condition: "new", category: "Kitchen", seller: "Lily C.", distance: "0.4 mi", emoji: "☕", auction: false, img: "bg-pink-100", badge: "Handmade" },
];

const auctionItems = [
{
id: 1, title: "Antique Wall Clock", emoji: "🕰️", currentBid: 200, minBid: 210,
endTime: Date.now() + 1000 * 60 * 47 + 1000 * 23,
seller: "James R.", bids: 8, img: "bg-amber-100",
},
{
id: 2, title: "Vintage Camera Leica", emoji: "📷", currentBid: 340, minBid: 355,
endTime: Date.now() + 1000 * 60 * 60 * 3 + 1000 * 60 * 12,
seller: "Paul M.", bids: 14, img: "bg-red-100",
},
{
id: 3, title: "Rare Vinyl Records Box", emoji: "🎵", currentBid: 75, minBid: 80,
endTime: Date.now() + 1000 * 60 * 60 * 11,
seller: "Dave S.", bids: 5, img: "bg-indigo-100",
},
];

const categories = ["All", "Furniture", "Sports", "Kitchen", "Decor", "Gaming", "Garden", "Electronics"];

function useCountdown(endTime) {
const [timeLeft, setTimeLeft] = useState("");
useEffect(() => {
const tick = () => {
const diff = endTime - Date.now();
if (diff <= 0) { setTimeLeft("Ended"); return; }
const h = Math.floor(diff / 3600000);
const m = Math.floor((diff % 3600000) / 60000);
const s = Math.floor((diff % 60000) / 1000);
setTimeLeft(`${h}h ${m}m ${s}s`);
};
tick();
const id = setInterval(tick, 1000);
return () => clearInterval(id);
}, [endTime]);
return timeLeft;
}

function AuctionCard({ item }) {
const timeLeft = useCountdown(item.endTime);
const [bid, setBid] = useState(item.minBid);
const [placed, setPlaced] = useState(false);
const [currentBid, setCurrentBid] = useState(item.currentBid);
const [bidCount, setBidCount] = useState(item.bids);

const placeBid = () => {
if (bid >= item.minBid) {
setCurrentBid(bid);
setBidCount(b => b + 1);
setPlaced(true);
setTimeout(() => setPlaced(false), 2500);
setBid(bid + 10);
}
};

return (
<div style={{background:"white", borderRadius:24, overflow:"hidden", boxShadow:"0 4px 24px rgba(0,0,0,0.10)", border:"2px solid #FFD166", transition:"transform 0.2s", cursor:"pointer"}}
onMouseEnter={e=>e.currentTarget.style.transform="translateY(-4px)"}
onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
<div className={item.img} style={{height:110, display:"flex", alignItems:"center", justifyContent:"center", fontSize:52, position:"relative"}}>
{item.emoji}
<div style={{position:"absolute", top:10, right:12, background:"#EF476F", color:"white", borderRadius:20, padding:"3px 10px", fontSize:11, fontWeight:700, fontFamily:"'Nunito', sans-serif"}}>
🔨 LIVE AUCTION
</div>
</div>
<div style={{padding:"14px 18px 18px"}}>
<div style={{fontFamily:"'Nunito', sans-serif", fontWeight:800, fontSize:15, color:"#1a1a2e", marginBottom:4}}>{item.title}</div>
<div style={{fontSize:12, color:"#888", marginBottom:10}}>by {item.seller} · {item.bids} bids</div>

<div style={{display:"flex", justifyContent:"space-between", alignItems:"center", background:"#FFF3CD", borderRadius:12, padding:"8px 12px", marginBottom:12}}>
<div>
<div style={{fontSize:10, color:"#888", fontFamily:"'Nunito',sans-serif"}}>Current Bid</div>
<div style={{fontFamily:"'Nunito',sans-serif", fontWeight:900, fontSize:20, color:"#EF476F"}}>${currentBid}</div>
</div>
<div style={{textAlign:"right"}}>
<div style={{fontSize:10, color:"#888", fontFamily:"'Nunito',sans-serif"}}>Ends In</div>
<div style={{fontFamily:"'Nunito',sans-serif", fontWeight:800, fontSize:13, color:"#06D6A0"}}>{timeLeft}</div>
</div>
</div>

<div style={{display:"flex", gap:8}}>
<input type="number" value={bid} onChange={e=>setBid(Number(e.target.value))} min={item.minBid}
style={{flex:1, border:"2px solid #FFD166", borderRadius:12, padding:"8px 10px", fontFamily:"'Nunito',sans-serif", fontWeight:700, fontSize:14, outline:"none", background:"#FFFBF0"}}/>
<button onClick={placeBid}
style={{background: placed ? "#06D6A0" : "linear-gradient(135deg,#EF476F,#FF6B35)", color:"white", border:"none", borderRadius:12, padding:"8px 16px", fontFamily:"'Nunito',sans-serif", fontWeight:800, fontSize:13, cursor:"pointer", transition:"all 0.3s", whiteSpace:"nowrap"}}>
{placed ? "✓ Bid!" : "Place Bid"}
</button>
</div>
<div style={{fontSize:11, color:"#aaa", marginTop:6, fontFamily:"'Nunito',sans-serif"}}>Min. bid: ${item.minBid}</div>
</div>
</div>
);
}

function ListingCard({ item, onBuy }) {
const [liked, setLiked] = useState(false);
return (
<div style={{background:"white", borderRadius:22, overflow:"hidden", boxShadow:"0 2px 18px rgba(0,0,0,0.08)", border:"1.5px solid #F0F0F0", transition:"all 0.2s", cursor:"pointer", position:"relative"}}
onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow="0 8px 32px rgba(0,0,0,0.13)"}}
onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="0 2px 18px rgba(0,0,0,0.08)"}}>
{item.badge && (
<div style={{position:"absolute", top:10, left:10, background: item.badge.includes("Auction") ? "#EF476F" : item.badge==="New" ? "#06D6A0" : "#FFD166", color: item.badge==="Hot Deal"?"#1a1a2e":"white", borderRadius:20, padding:"3px 10px", fontSize:10, fontWeight:800, fontFamily:"'Nunito',sans-serif", zIndex:2}}>
{item.badge}
</div>
)}
<button onClick={()=>setLiked(!liked)}
style={{position:"absolute", top:10, right:10, background:"white", border:"none", borderRadius:"50%", width:32, height:32, fontSize:16, cursor:"pointer", boxShadow:"0 2px 8px rgba(0,0,0,0.12)", zIndex:2, display:"flex", alignItems:"center", justifyContent:"center"}}>
{liked ? "❤️" : "🤍"}
</button>
<div className={item.img} style={{height:100, display:"flex", alignItems:"center", justifyContent:"center", fontSize:46}}>
{item.emoji}
</div>
<div style={{padding:"12px 14px 14px"}}>
<div style={{fontFamily:"'Nunito',sans-serif", fontWeight:800, fontSize:14, color:"#1a1a2e", marginBottom:2}}>{item.title}</div>
<div style={{fontSize:11, color:"#aaa", marginBottom:8, fontFamily:"'Nunito',sans-serif"}}>📍 {item.distance} · {item.seller}</div>
<div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
<div style={{fontFamily:"'Nunito',sans-serif", fontWeight:900, fontSize:20, color:"#EF476F"}}>${item.price}</div>
<button onClick={()=>onBuy(item)}
style={{background:"linear-gradient(135deg,#06D6A0,#118AB2)", color:"white", border:"none", borderRadius:12, padding:"7px 14px", fontFamily:"'Nunito',sans-serif", fontWeight:800, fontSize:12, cursor:"pointer"}}>
Buy Now
</button>
</div>
<div style={{marginTop:8, display:"flex", gap:6}}>
<span style={{background: item.condition==="new"?"#E8FFF5":"#FFF3E0", color: item.condition==="new"?"#06D6A0":"#FF6B35", borderRadius:8, padding:"2px 8px", fontSize:10, fontWeight:700, fontFamily:"'Nunito',sans-serif"}}>
{item.condition==="new"?"✨ New":"♻️ Used"}
</span>
<span style={{background:"#F0F4FF", color:"#118AB2", borderRadius:8, padding:"2px 8px", fontSize:10, fontWeight:700, fontFamily:"'Nunito',sans-serif"}}>
{item.category}
</span>
</div>
</div>
</div>
);
}

function Modal({ item, onClose }) {
if (!item) return null;
return (
<div style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:100, display:"flex", alignItems:"center", justifyContent:"center", padding:20}}
onClick={onClose}>
<div style={{background:"white", borderRadius:28, padding:32, maxWidth:400, width:"100%", textAlign:"center", boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}
onClick={e=>e.stopPropagation()}>
<div style={{fontSize:64, marginBottom:12}}>{item.emoji}</div>
<h2 style={{fontFamily:"'Nunito',sans-serif", fontWeight:900, color:"#1a1a2e", marginBottom:8}}>{item.title}</h2>
<p style={{color:"#888", fontFamily:"'Nunito',sans-serif", marginBottom:16}}>Sold by {item.seller} · {item.distance} away</p>
<div style={{background:"linear-gradient(135deg,#FFD166,#FF6B35)", borderRadius:16, padding:"12px 20px", marginBottom:20}}>
<div style={{fontFamily:"'Nunito',sans-serif", fontWeight:900, fontSize:32, color:"white"}}>${item.price}</div>
</div>
<button style={{width:"100%", background:"linear-gradient(135deg,#EF476F,#FF6B35)", color:"white", border:"none", borderRadius:16, padding:"14px", fontFamily:"'Nunito',sans-serif", fontWeight:900, fontSize:16, cursor:"pointer", marginBottom:10}}>
💬 Message Seller
</button>
<button onClick={onClose} style={{width:"100%", background:"#F5F5F5", color:"#888", border:"none", borderRadius:16, padding:"12px", fontFamily:"'Nunito',sans-serif", fontWeight:700, fontSize:14, cursor:"pointer"}}>
Close
</button>
</div>
</div>
);
}

export default function App() {
const [tab, setTab] = useState("browse");
const [category, setCategory] = useState("All");
const [search, setSearch] = useState("");
const [filter, setFilter] = useState("all");
const [selectedItem, setSelectedItem] = useState(null);
const [showSellModal, setShowSellModal] = useState(false);
const [sellForm, setSellForm] = useState({title:"", price:"", condition:"used", category:"Furniture", isAuction:false});
const [submitted, setSubmitted] = useState(false);

const filtered = listings.filter(l => {
const matchCat = category === "All" || l.category === category;
const matchSearch = l.title.toLowerCase().includes(search.toLowerCase());
const matchFilter = filter === "all" || l.condition === filter;
return matchCat && matchSearch && matchFilter;
});

const handleSubmitSell = () => {
if (!sellForm.title || !sellForm.price) return;
setSubmitted(true);
setTimeout(() => { setSubmitted(false); setShowSellModal(false); setSellForm({title:"",price:"",condition:"used",category:"Furniture",isAuction:false}); }, 2000);
};

return (
<div style={{minHeight:"100vh", background:"#FFF9F0", fontFamily:"'Nunito', sans-serif"}}>
<link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Fredoka+One&display=swap" rel="stylesheet"/>

{/* HEADER */}
<div style={{background:"linear-gradient(135deg,#EF476F 0%,#FF6B35 50%,#FFD166 100%)", padding:"0 20px", boxShadow:"0 4px 20px rgba(239,71,111,0.3)"}}>
<div style={{maxWidth:900, margin:"0 auto", padding:"16px 0", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12}}>
<div>
<div style={{fontFamily:"'Fredoka One', cursive", fontSize:28, color:"white", letterSpacing:1}}>🏘️ NeighborMart</div>
<div style={{fontSize:11, color:"rgba(255,255,255,0.85)", fontWeight:600}}>📍 Your neighborhood marketplace</div>
</div>
<div style={{display:"flex", gap:10, alignItems:"center"}}>
<div style={{background:"rgba(255,255,255,0.2)", borderRadius:20, padding:"8px 16px", color:"white", fontSize:13, fontWeight:700, cursor:"pointer"}}>
👤 Sign In
</div>
<button onClick={()=>setShowSellModal(true)}
style={{background:"white", color:"#EF476F", border:"none", borderRadius:20, padding:"9px 20px", fontFamily:"'Nunito',sans-serif", fontWeight:900, fontSize:14, cursor:"pointer", boxShadow:"0 4px 12px rgba(0,0,0,0.15)"}}>
+ Sell Item
</button>
</div>
</div>
</div>

{/* SEARCH BAR */}
<div style={{background:"white", padding:"16px 20px", boxShadow:"0 2px 12px rgba(0,0,0,0.06)"}}>
<div style={{maxWidth:900, margin:"0 auto", display:"flex", gap:10}}>
<div style={{flex:1, position:"relative"}}>
<span style={{position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", fontSize:18}}>🔍</span>
<input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search in your neighborhood..."
style={{width:"100%", border:"2px solid #FFD166", borderRadius:16, padding:"12px 16px 12px 42px", fontFamily:"'Nunito',sans-serif", fontWeight:600, fontSize:14, outline:"none", background:"#FFFBF0", boxSizing:"border-box"}}/>
</div>
<select value={filter} onChange={e=>setFilter(e.target.value)}
style={{border:"2px solid #FFD166", borderRadius:16, padding:"10px 14px", fontFamily:"'Nunito',sans-serif", fontWeight:700, fontSize:13, outline:"none", background:"#FFFBF0", color:"#1a1a2e", cursor:"pointer"}}>
<option value="all">All Items</option>
<option value="new">✨ New Only</option>
<option value="used">♻️ Used Only</option>
</select>
</div>
</div>

{/* TABS */}
<div style={{maxWidth:900, margin:"20px auto 0", padding:"0 20px", display:"flex", gap:10}}>
{[{id:"browse",label:"🛍️ Browse",desc:"Shop items"},{id:"auction",label:"🔨 Auctions",desc:"Live bidding"},{id:"nearby",label:"📍 Near Me",desc:"Within 1 mi"}].map(t=>(
<button key={t.id} onClick={()=>setTab(t.id)}
style={{flex:1, background: tab===t.id ? "linear-gradient(135deg,#EF476F,#FF6B35)" : "white", color: tab===t.id ? "white" : "#888", border: tab===t.id ? "none" : "2px solid #F0F0F0", borderRadius:18, padding:"12px 8px", fontFamily:"'Nunito',sans-serif", fontWeight:800, fontSize:14, cursor:"pointer", boxShadow: tab===t.id ? "0 4px 16px rgba(239,71,111,0.3)" : "none", transition:"all 0.2s"}}>
{t.label}
</button>
))}
</div>

<div style={{maxWidth:900, margin:"0 auto", padding:"20px"}}>

{/* BROWSE TAB */}
{tab === "browse" && (
<>
{/* Categories */}
<div style={{display:"flex", gap:8, overflowX:"auto", marginBottom:20, paddingBottom:4}}>
{categories.map(c=>(
<button key={c} onClick={()=>setCategory(c)}
style={{background: category===c ? "#1a1a2e" : "white", color: category===c ? "white" : "#555", border: category===c ? "none" : "2px solid #F0F0F0", borderRadius:20, padding:"8px 18px", fontFamily:"'Nunito',sans-serif", fontWeight:700, fontSize:13, cursor:"pointer", whiteSpace:"nowrap", transition:"all 0.2s"}}>
{c}
</button>
))}
</div>

{/* Stats bar */}
<div style={{background:"linear-gradient(135deg,#F0FFF8,#E8F4FF)", borderRadius:16, padding:"12px 18px", marginBottom:20, display:"flex", gap:24, flexWrap:"wrap"}}>
<span style={{fontWeight:700, color:"#06D6A0", fontSize:13}}>✅ {filtered.length} listings near you</span>
<span style={{fontWeight:700, color:"#118AB2", fontSize:13}}>🏃 Avg. 0.6 mi away</span>
<span style={{fontWeight:700, color:"#EF476F", fontSize:13}}>🔨 {auctionItems.length} live auctions</span>
</div>

<div style={{display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(200px, 1fr))", gap:16}}>
{filtered.map(item=>(
<ListingCard key={item.id} item={item} onBuy={setSelectedItem}/>
))}
</div>
{filtered.length === 0 && (
<div style={{textAlign:"center", padding:"60px 20px", color:"#ccc"}}>
<div style={{fontSize:48, marginBottom:12}}>🔍</div>
<div style={{fontWeight:800, fontSize:18, color:"#aaa"}}>No items found</div>
<div style={{fontSize:14, marginTop:4}}>Try a different search or category</div>
</div>
)}
</>
)}

{/* AUCTION TAB */}
{tab === "auction" && (
<>
<div style={{background:"linear-gradient(135deg,#EF476F,#FF6B35)", borderRadius:20, padding:"20px 24px", marginBottom:24, color:"white"}}>
<div style={{fontFamily:"'Fredoka One',cursive", fontSize:22, marginBottom:4}}>🔨 Live Auctions Near You</div>
<div style={{fontSize:13, opacity:0.9, fontWeight:600}}>Bid on unique items from your neighbors · Prices update live</div>
</div>
<div style={{display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(250px, 1fr))", gap:18}}>
{auctionItems.map(item=><AuctionCard key={item.id} item={item}/>)}
</div>
<div style={{background:"white", borderRadius:20, padding:"20px 24px", marginTop:24, border:"2px dashed #FFD166", textAlign:"center"}}>
<div style={{fontSize:32, marginBottom:8}}>🎯</div>
<div style={{fontWeight:800, fontSize:16, color:"#1a1a2e", marginBottom:4}}>Want to auction your item?</div>
<div style={{color:"#888", fontSize:13, marginBottom:14}}>Set a starting price and let neighbors bid!</div>
<button onClick={()=>{ setShowSellModal(true); setSellForm(f=>({...f,isAuction:true})); }}
style={{background:"linear-gradient(135deg,#EF476F,#FF6B35)", color:"white", border:"none", borderRadius:14, padding:"12px 28px", fontFamily:"'Nunito',sans-serif", fontWeight:900, fontSize:15, cursor:"pointer"}}>
Start an Auction
</button>
</div>
</>
)}

{/* NEARBY TAB */}
{tab === "nearby" && (
<>
<div style={{background:"white", borderRadius:20, height:260, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:20, border:"2px solid #F0F0F0", overflow:"hidden", position:"relative"}}>
<div style={{position:"absolute", inset:0, background:"linear-gradient(135deg,#E8F4FF,#F0FFF8)", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:10}}>
<div style={{fontSize:52}}>🗺️</div>
<div style={{fontWeight:800, fontSize:18, color:"#1a1a2e"}}>Interactive Map</div>
<div style={{color:"#888", fontSize:13}}>Enable location to see items near you</div>
<button style={{background:"linear-gradient(135deg,#06D6A0,#118AB2)", color:"white", border:"none", borderRadius:14, padding:"10px 24px", fontFamily:"'Nunito',sans-serif", fontWeight:800, fontSize:14, cursor:"pointer", marginTop:4}}>
📍 Enable Location
</button>
</div>
{/* Fake map pins */}
{[{x:"20%",y:"35%",e:"🛋️"},{x:"55%",y:"25%",e:"🚲"},{x:"75%",y:"55%",e:"📷"},{x:"35%",y:"65%",e:"🎮"},{x:"60%",y:"75%",e:"🌵"}].map((p,i)=>(
<div key={i} style={{position:"absolute", left:p.x, top:p.y, background:"white", borderRadius:"50%", width:36, height:36, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, boxShadow:"0 4px 12px rgba(0,0,0,0.2)", border:"2px solid #FFD166", zIndex:3}}>
{p.e}
</div>
))}
</div>
<div style={{display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(200px, 1fr))", gap:14}}>
{[...listings].sort((a,b)=>parseFloat(a.distance)-parseFloat(b.distance)).map(item=>(
<ListingCard key={item.id} item={item} onBuy={setSelectedItem}/>
))}
</div>
</>
)}
</div>

{/* BUY MODAL */}
<Modal item={selectedItem} onClose={()=>setSelectedItem(null)}/>

{/* SELL MODAL */}
{showSellModal && (
<div style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:100, display:"flex", alignItems:"center", justifyContent:"center", padding:20}}
onClick={()=>setShowSellModal(false)}>
<div style={{background:"white", borderRadius:28, padding:28, maxWidth:420, width:"100%", maxHeight:"90vh", overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
<div style={{fontFamily:"'Fredoka One',cursive", fontSize:24, color:"#EF476F", marginBottom:4}}>+ List an Item</div>
<div style={{color:"#aaa", fontSize:13, marginBottom:20}}>Reach neighbors within 2 miles 🏘️</div>

{submitted ? (
<div style={{textAlign:"center", padding:"30px 0"}}>
<div style={{fontSize:56}}>🎉</div>
<div style={{fontWeight:900, fontSize:20, color:"#06D6A0", marginTop:8}}>Listed Successfully!</div>
</div>
) : (
<>
<div style={{marginBottom:14}}>
<label style={{fontWeight:800, fontSize:13, color:"#555", display:"block", marginBottom:5}}>Item Title *</label>
<input value={sellForm.title} onChange={e=>setSellForm(f=>({...f,title:e.target.value}))} placeholder="e.g. Red Bicycle, Old Lamp..."
style={{width:"100%", border:"2px solid #FFD166", borderRadius:12, padding:"10px 14px", fontFamily:"'Nunito',sans-serif", fontWeight:600, fontSize:14, outline:"none", boxSizing:"border-box"}}/>
</div>
<div style={{marginBottom:14}}>
<label style={{fontWeight:800, fontSize:13, color:"#555", display:"block", marginBottom:5}}>Price ($) *</label>
<input type="number" value={sellForm.price} onChange={e=>setSellForm(f=>({...f,price:e.target.value}))} placeholder="0"
style={{width:"100%", border:"2px solid #FFD166", borderRadius:12, padding:"10px 14px", fontFamily:"'Nunito',sans-serif", fontWeight:600, fontSize:14, outline:"none", boxSizing:"border-box"}}/>
</div>
<div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:14}}>
<div>
<label style={{fontWeight:800, fontSize:13, color:"#555", display:"block", marginBottom:5}}>Condition</label>
<select value={sellForm.condition} onChange={e=>setSellForm(f=>({...f,condition:e.target.value}))}
style={{width:"100%", border:"2px solid #FFD166", borderRadius:12, padding:"10px 12px", fontFamily:"'Nunito',sans-serif", fontWeight:700, fontSize:13, outline:"none", background:"white"}}>
<option value="new">✨ New</option>
<option value="used">♻️ Used</option>
</select>
</div>
<div>
<label style={{fontWeight:800, fontSize:13, color:"#555", display:"block", marginBottom:5}}>Category</label>
<select value={sellForm.category} onChange={e=>setSellForm(f=>({...f,category:e.target.value}))}
style={{width:"100%", border:"2px solid #FFD166", borderRadius:12, padding:"10px 12px", fontFamily:"'Nunito',sans-serif", fontWeight:700, fontSize:13, outline:"none", background:"white"}}>
{categories.filter(c=>c!=="All").map(c=><option key={c}>{c}</option>)}
</select>
</div>
</div>
<div style={{background: sellForm.isAuction?"#FFF0F3":"#F8F9FA", border:`2px solid ${sellForm.isAuction?"#EF476F":"#E0E0E0"}`, borderRadius:14, padding:"12px 16px", marginBottom:18, cursor:"pointer", display:"flex", alignItems:"center", gap:12}}
onClick={()=>setSellForm(f=>({...f,isAuction:!f.isAuction}))}>
<div style={{width:22, height:22, borderRadius:6, background: sellForm.isAuction?"#EF476F":"white", border:`2px solid ${sellForm.isAuction?"#EF476F":"#ccc"}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, flexShrink:0}}>
{sellForm.isAuction && "✓"}
</div>
<div>
<div style={{fontWeight:800, fontSize:14, color:"#1a1a2e"}}>🔨 Enable Auction Mode</div>
<div style={{fontSize:11, color:"#888"}}>Let neighbors bid on your item</div>
</div>
</div>
<button onClick={handleSubmitSell}
style={{width:"100%", background:"linear-gradient(135deg,#EF476F,#FF6B35)", color:"white", border:"none", borderRadius:16, padding:"14px", fontFamily:"'Nunito',sans-serif", fontWeight:900, fontSize:16, cursor:"pointer", marginBottom:10}}>
🚀 List My Item
</button>
<button onClick={()=>setShowSellModal(false)}
style={{width:"100%", background:"#F5F5F5", color:"#888", border:"none", borderRadius:14, padding:"12px", fontFamily:"'Nunito',sans-serif", fontWeight:700, fontSize:14, cursor:"pointer"}}>
Cancel
</button>
</>
)}
</div>
</div>
)}
</div>
);
}
